import { SET_ORDER_LOCKED_NUMBER }  from './actionTypes';
 
import pickupOrderRemote from '../../api/pickupOrderRemote';
import ResponseError from '../../models/ResponseError';

function setOrderLocked(orderNumber: string) {
  return {
    type: SET_ORDER_LOCKED_NUMBER,
    data: orderNumber
  };
};

function requestOrderUnlocked (orderNumber: string) {

  return (dispatch: any) => {

    pickupOrderRemote.doGhaWhPoLock(orderNumber, false).then((resp) => {
        
      const result: {lock_status: string; gha_wh_user_name: string }| undefined = resp.result;
      const error: ResponseError | undefined = resp.error;

      if (result) {
        dispatch(setOrderLocked(''));
      };

      if (error) {
       console.log(error)
      };
    });
  };
}

export {
  setOrderLocked,
  requestOrderUnlocked
}